import { Link } from "react-router-dom";
import logo from "./tscnet-full-logo.png";
import { UserAvatar } from "../../components/UserAvatar/UserAvatar";
import "./TscNetHeader.css";

export const TscNetHeader = () => {
    return (
        <header id="perun-header">
            <div id="header-content-container">
                <Link id="link-tscNetHeader" to="/Study">
                    <img id="header-logo" src={logo} alt="Logo" />
                </Link>
                <UserAvatar />
            </div>
        </header>
    );
};
